import React from "react"
import ActiveAvatar from "avatar/nuno-ship.svg"
import InactiveAvatar from "avatar/nuno-ship-inactive.svg"

const NunoShip = ({ inactive, className = "", ...rest }) => {
  if (inactive) {
    return <img src={InactiveAvatar} className={`inactive ${className}`} {...rest} />
  }
  return <img src={ActiveAvatar} className={className} {...rest} />
}

export default NunoShip
